import { gql } from 'apollo-angular';

export const GET_FOOTER_BLOCK = gql`
  query GetFooterBlock {
    footerBlockCollection(limit: 5) {
      items {
        partneshipTitle
        partnershipLogosCollection(limit: 20) {
          items {
            __typename
            ... on ImageBlock {
              altText
              image {
                url
                description
                title
              }
            }
          }
        }
        navigationLinksTitle
        navigationLinksCollection(limit: 5) {
          items {
            __typename
            ... on NavigationListBlock {
              label
              url
              openInNewTab
            }
          }
        }
        socialMediaLinksTitle
        socialMediaLinksCollection(limit: 5) {
          items {
            __typename
            ... on SocialMediaBlock {
              platformName
              link
              icon {
                url
                title
              }
            }
          }
        }
        fundersAndSupportersTitle
        fundersAndSupportersSubTitle
        fundersSupportersLogosCollection(limit: 5) {
          items {
            __typename
            ... on ImageBlock {
              altText
              image {
                url
                description
                title
              }
            }
          }
        }
        fundersAndSupportersBody {
          json
        }
        copyrightInformation {
          json
        }
        bottomLogo {
          ... on ImageBlock {
            altText
            image {
              url
              description
              title
            }
          }
        }
      }
    }
  }
`;
